<template>
  <b-dropdown class="dropdown-form" ref="dropdown" v-on:hide="priceHidden"
              v-bind:class="{'color-button': (!defaultValue)}">
    <template slot="button-content">
      <i class="fas fa-money-bill-wave"></i> <span v-if="getMinPrice <= 0 && getMaxPrice <= 0">Price</span>
      <span v-if="getMinPrice > 0 && getMaxPrice <= 0">${{ setPriceString(getMinPrice) }}+</span>
      <span v-if="getMaxPrice > 0 && getMinPrice <= 0">Up to ${{ setPriceString(getMaxPrice) }}</span>
      <span v-if="getMaxPrice > 0 && getMinPrice > 0">${{ setPriceString(getMinPrice) }} - ${{ setPriceString(getMaxPrice) }}</span>
      <reset-button v-if="!defaultValue" v-on:x-button-clicked="resetPriceFilters"></reset-button>
    </template>
    <b-dropdown-form>
      <div class="container-fluid">
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <money class="form-control price-input" v-model="minPrice" v-bind="money"></money>
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <money class="form-control price-input" v-model="maxPrice" v-bind="money"></money>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p v-for="price in minPrices" v-bind:key="price" class="no-margin price-select text-center" v-on:click="updateMinPrice(price)">${{ price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p v-for="price in maxPrices" v-bind:key="price" class="no-margin price-select text-center" v-on:click="updateMaxPrice(price)">${{ price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import mixins from '../../../Mixins.js'
import { Money } from 'v-money'
import defaultValues from '../../../../../store/lib/defaultValues.js'
import ResetButton from '../../../../general/buttons/CircleEnclosedXButton.vue'

export default {
  data () {
    return {
      prices: [100000, 150000, 200000, 250000, 300000, 500000, 750000, 1000000],
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  mixins: [mixins],
  components: {
    Money,
    ResetButton
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getMinPrice',
      'getMaxPrice'
    ]),
    defaultValue () {
      return this.getMinPrice === defaultValues.minPrice && this.getMaxPrice === defaultValues.maxPrice
    },
    minPrice: {
      get () {
        return this.getMinPrice
      },
      set (value) {
        this.updateMinPrice(value)
      }
    },
    maxPrice: {
      get () {
        return this.getMaxPrice
      },
      set (value) {
        this.updateMaxPrice(value)
      }
    },
    minPrices () {
      var index = this.prices.length
      if (this.getMaxPrice > 0) {
        index = this.prices.findIndex((price) => {
          return price > this.getMaxPrice
        })
      }
      return this.prices.slice(0, index)
    },
    maxPrices () {
      var index = 0
      if (this.getMinPrice > 0) {
        index = this.prices.findIndex((price) => {
          return price > this.getMinPrice
        })
      }
      return this.prices.slice(index)
    }
  },
  methods: {
    priceHidden () {
      if (this.getMinPrice >= this.getMaxPrice) this.updateMaxPrice(0)
      if (this.getMinPrice > 1000000) this.updateMinPrice(1000000)
    },
    ...mapMutations('homeSearch', [
      'updateMinPrice',
      'updateMaxPrice'
    ]),
    resetPriceFilters () {
      this.updateMinPrice(defaultValues.minPrice)
      this.updateMaxPrice(defaultValues.maxPrice)
    }
  }
}
</script>

<style scoped>
.btn-primary {
  width: auto !important;
}
.dropdown-form >>> .dropdown-item:hover {
  background-color: rgb(254, 237, 170) !important;
}

.dropdown-form >>> .btn {
  min-width: 160px;
  background-color: white !important;
  color: rgb(79, 79, 79);
  border-style: solid !important;
  border-color: gray !important;
  border-width: 1px !important;
  border-radius: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  margin-right: .3rem;
  margin-left: .3rem;
}

.dropdown-form >>> .dropdown-toggle::after {
  display:none;
}

.price-select:hover {
  background-color: rgb(254, 237, 170);
}

.price-select {
  border-radius: 30px;
  cursor: pointer;
}

.price-input {
  width: 100% !important;
}

.right-dropdown-col, .left-dropdown-col {
  padding: 0;
}

.middle-dash {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: .5rem;
  margin-bottom: 0;
}

.dropdown-row {
  width: 300px;
}

.terms-text {
  text-decoration: underline;
  cursor: pointer;
}

.no-margin {
  margin: 0;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/Price.vue